import { defineComponent as p, openBlock as t, createElementBlock as o, mergeProps as i, unref as e, renderSlot as u, createElementVNode as l, createCommentVNode as g } from "vue";
import { useScalarIcon as h } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, Z = { key: 1 }, M = { key: 2 }, f = { key: 3 }, L = { key: 4 }, A = { key: 5 }, k = {
  name: "ScalarIconOption"
}, _ = /* @__PURE__ */ p({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const r = H, { bind: s, weight: n } = h(r);
    return (d, a) => (t(), o("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      u(d.$slots, "default"),
      e(n) === "bold" ? (t(), o("g", m, a[0] || (a[0] = [
        l("path", { d: "M236,192a12,12,0,0,1-12,12H160.94a19.89,19.89,0,0,1-17.88-11.06L92.58,92H32a12,12,0,0,1,0-24H95.06a19.89,19.89,0,0,1,17.88,11.06L163.42,180H224A12,12,0,0,1,236,192ZM152,92h72a12,12,0,0,0,0-24H152a12,12,0,0,0,0,24Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (t(), o("g", Z, a[1] || (a[1] = [
        l("path", {
          d: "M224,80V192H48a16,16,0,0,1-16-16V80Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M232,192a8,8,0,0,1-8,8H160.94a15.92,15.92,0,0,1-14.31-8.84L95.06,88H32a8,8,0,0,1,0-16H95.06a15.92,15.92,0,0,1,14.31,8.84L160.94,184H224A8,8,0,0,1,232,192ZM152,88h72a8,8,0,0,0,0-16H152a8,8,0,0,0,0,16Z" }, null, -1)
      ]))) : e(n) === "fill" ? (t(), o("g", M, a[2] || (a[2] = [
        l("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM200,176H152.94a15.92,15.92,0,0,1-14.31-8.84L103.06,96H56a8,8,0,0,1,0-16h47.06a15.92,15.92,0,0,1,14.31,8.84L152.94,160H200a8,8,0,0,1,0,16Zm0-80H152a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : e(n) === "light" ? (t(), o("g", f, a[3] || (a[3] = [
        l("path", { d: "M230,192a6,6,0,0,1-6,6H160.94a13.92,13.92,0,0,1-12.52-7.74L96.84,87.11A2,2,0,0,0,95.06,86H32a6,6,0,0,1,0-12H95.06a13.92,13.92,0,0,1,12.52,7.74l51.58,103.15a2,2,0,0,0,1.78,1.11H224A6,6,0,0,1,230,192ZM152,86h72a6,6,0,0,0,0-12H152a6,6,0,0,0,0,12Z" }, null, -1)
      ]))) : e(n) === "regular" ? (t(), o("g", L, a[4] || (a[4] = [
        l("path", { d: "M232,192a8,8,0,0,1-8,8H160.94a15.92,15.92,0,0,1-14.31-8.84L95.06,88H32a8,8,0,0,1,0-16H95.06a15.92,15.92,0,0,1,14.31,8.84L160.94,184H224A8,8,0,0,1,232,192ZM152,88h72a8,8,0,0,0,0-16H152a8,8,0,0,0,0,16Z" }, null, -1)
      ]))) : e(n) === "thin" ? (t(), o("g", A, a[5] || (a[5] = [
        l("path", { d: "M228,192a4,4,0,0,1-4,4H160.94a11.94,11.94,0,0,1-10.73-6.63L98.63,86.21A4,4,0,0,0,95.06,84H32a4,4,0,0,1,0-8H95.06a11.94,11.94,0,0,1,10.73,6.63l51.58,103.16a4,4,0,0,0,3.57,2.21H224A4,4,0,0,1,228,192ZM152,84h72a4,4,0,0,0,0-8H152a4,4,0,0,0,0,8Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  _ as default
};
